module.exports = __webpack_public_path__ + "static/img/sre_arc.24bfef2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sre_arc.png
// module id = hRdz
// module chunks = 0